import {
  Box,
  Typography,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ListTomadaPreco from "../../components/TomadaPreco/ListTomadaPreco";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useStoreActions, useStoreState } from "easy-peasy";
import api from "../../services/api";
import AcompanhaOrcamentosDinamico from "./AcompanhaOrcamentosDinamico";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const DialogoAcompanhaOrcamentosNovo = () => {
  let loading = useStoreState((state) => state.nav.loading);
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  let currProcesso = useStoreState((state) => state.processo.current);

  const [expanded, setExpanded] = useState(false);
  const [tecnologiasSolicitadas, setTecnologiasSolicitadas] = useState([]);
  const [tipoCargaSelecionada, setTipoCargaSelecionada] = useState(null);

  useEffect(() => {
    startLoading();
    api.http
      .get(`/orcamentos/processo/tomada/tecnologia/${currProcesso.id}/tomada/`)
      .then((response) => {
        setTecnologiasSolicitadas(response.data);
        stopLoading();
      })
      .catch((error) => {
        stopLoading({
          message: error.toString(),
          severity: "error",
        });
      });
  }, []);

  const verificaTipoCarga = (tipo) => {
    return tecnologiasSolicitadas.some((item) => item.tipo_carga === tipo);
  };

  const handleChangeAccordion = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleTabClick = (tipoCarga) => {
    setTipoCargaSelecionada(tipoCarga);
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: "background.paper",
        display: "flex",
        height: "100vh",
      }}
    >
      {/* Painel lateral com abas */}
      <Box
        sx={{
          width: "15%",
          borderRight: 1,
          borderColor: "divider",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Accordion para TECNOLOGIAS */}
        <Accordion
          expanded={expanded === "tecnologias"}
          onChange={handleChangeAccordion("tecnologias")}
          sx={{ boxShadow: "none", borderBottom: 1, borderColor: "divider" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="tecnologias-content"
            id="tecnologias-header"
          >
            <Typography fontWeight="bold" fontSize="1rem" color="text.secondary">
              TECNOLOGIAS
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ maxHeight: "300px", overflowY: "auto" }}>
            <Tabs orientation="vertical" variant="scrollable" value={false}>
              {verificaTipoCarga("iluminacao") && (
                <Tab
                  label="ILUMINAÇÃO"
                  onClick={() => handleTabClick("iluminacao")}
                />
              )}
              {verificaTipoCarga("condicionadores_de_ar") && (
                <Tab
                  label="CONDICIONADORES DE AR"
                  onClick={() => handleTabClick("condicionadores_de_ar")}
                />
              )}
              {verificaTipoCarga("motores_eletricos") && (
                <Tab
                  label="MOTORES ELÉTRICOS"
                  onClick={() => handleTabClick("motores_eletricos")}
                />
              )}
              {verificaTipoCarga("bombas") && (
                <Tab
                  label="BOMBAS"
                  onClick={() => handleTabClick("bombas")}
                />
              )}
              {verificaTipoCarga("compressores") && (
                <Tab
                  label="COMPRESSORES"
                  onClick={() => handleTabClick("compressores")}
                />
              )}
              {verificaTipoCarga("ventiladores") && (
                <Tab
                  label="VENTILADORES"
                  onClick={() => handleTabClick("ventiladores")}
                />
              )}
              {verificaTipoCarga("inversores_de_frequencia") && (
                <Tab
                  label="INVERSORES DE FREQUÊNCIA"
                  onClick={() => handleTabClick("inversores_de_frequencia")}
                />
              )}
              {verificaTipoCarga("refrigeracao") && (
                <Tab
                  label="REFRIGERAÇÃO"
                  onClick={() => handleTabClick("refrigeracao")}
                />
              )}
              {verificaTipoCarga("sistema_de_gerenciamento_de_energia") && (
                <Tab
                  label="SISTEMA DE GERENCIAMENTO DE ENERGIA (SGE)"
                  onClick={() =>
                    handleTabClick("sistema_de_gerenciamento_de_energia")
                  }
                />
              )}
              {verificaTipoCarga("cogeracao") && (
                <Tab
                  label="COGERAÇÃO"
                  onClick={() => handleTabClick("cogeracao")}
                />
              )}
              {verificaTipoCarga("isolamento_termico") && (
                <Tab
                  label="ISOLAMENTO TÉRMICO"
                  onClick={() => handleTabClick("isolamento_termico")}
                />
              )}
              {verificaTipoCarga("caldeiras") && (
                <Tab
                  label="CALDEIRAS"
                  onClick={() => handleTabClick("caldeiras")}
                />
              )}
              {verificaTipoCarga("queimadores") && (
                <Tab
                  label="QUEIMADORES"
                  onClick={() => handleTabClick("queimadores")}
                />
              )}
              {verificaTipoCarga("fornos") && (
                <Tab
                  label="FORNOS"
                  onClick={() => handleTabClick("fornos")}
                />
              )}
              {verificaTipoCarga("aquecedores") && (
                <Tab
                  label="AQUECEDORES"
                  onClick={() => handleTabClick("aquecedores")}
                />
              )}
              {verificaTipoCarga("coletores_solares") && (
                <Tab
                  label="COLETORES SOLARES"
                  onClick={() => handleTabClick("coletores_solares")}
                />
              )}
              {verificaTipoCarga("reservatorios_termicos") && (
                <Tab
                  label="RESERVATÓRIOS TÉRMICOS"
                  onClick={() => handleTabClick("reservatorios_termicos")}
                />
              )}
              {verificaTipoCarga("trocadores_de_calor") && (
                <Tab
                  label="TROCADORES DE CALOR"
                  onClick={() => handleTabClick("trocadores_de_calor")}
                />
              )}
              {verificaTipoCarga("bombas_de_calor") && (
                <Tab
                  label="BOMBAS DE CALOR"
                  onClick={() => handleTabClick("bombas_de_calor")}
                />
              )}
            </Tabs>
          </AccordionDetails>
        </Accordion>

        {/* Accordion para SERVIÇOS */}
        <Accordion
          expanded={expanded === "servicos"}
          onChange={handleChangeAccordion("servicos")}
          sx={{ boxShadow: "none", borderBottom: 1, borderColor: "divider" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="servicos-content"
            id="servicos-header"
          >
            <Typography fontWeight="bold" fontSize="1rem" color="text.secondary">
              SERVIÇOS
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ maxHeight: "300px", overflowY: "auto" }}>
            <Tabs orientation="vertical" variant="scrollable" value={false}>
              {verificaTipoCarga("logistica_reversa") && (
                <Tab
                  label="LOGÍSTICA REVERSA"
                  onClick={() => handleTabClick("logistica_reversa")}
                />
              )}
              {verificaTipoCarga("comissionamento") && (
                <Tab
                  label="COMISSIONAMENTO"
                  onClick={() => handleTabClick("comissionamento")}
                />
              )}
              {verificaTipoCarga("montagem_e_desmontagem") && (
                <Tab
                  label="MONTAGEM E DESMONTAGEM"
                  onClick={() => handleTabClick("montagem_e_desmontagem")}
                />
              )}
              {verificaTipoCarga("medicao_de_sistemas_e_insumos") && (
                <Tab
                  label="MEDIÇÃO DE SISTEMAS E INSUMOS"
                  onClick={() =>
                    handleTabClick("medicao_de_sistemas_e_insumos")
                  }
                />
              )}
              {verificaTipoCarga("manutencao") && (
                <Tab
                  label="MANUTENÇÃO"
                  onClick={() => handleTabClick("manutencao")}
                />
              )}
              {verificaTipoCarga("obras_eletricas") && (
                <Tab
                  label="OBRAS ELÉTRICAS"
                  onClick={() => handleTabClick("obras_eletricas")}
                />
              )}
              {verificaTipoCarga("obras_de_adequacao_civil_mecanica_e_hidraulica") && (
                <Tab
                  label="OBRAS DE ADEQUAÇÃO CIVIL, MECÂNICA E HIDRÁULICA"
                  onClick={() =>
                    handleTabClick(
                      "obras_de_adequacao_civil_mecanica_e_hidraulica"
                    )
                  }
                />
              )}
              {verificaTipoCarga("dimensionamento_de_projetos") && (
                <Tab
                  label="DIMENSIONAMENTO DE PROJETOS"
                  onClick={() =>
                    handleTabClick("dimensionamento_de_projetos")
                  }
                />
              )}
              {verificaTipoCarga("supervisao_de_montagem_startup_de_equipamentos") && (
                <Tab
                  label="SUPERVISÃO DE MONTAGEM/STARTUP DE EQUIPAMENTOS"
                  onClick={() =>
                    handleTabClick(
                      "supervisao_de_montagem_startup_de_equipamentos"
                    )
                  }
                />
              )}
            </Tabs>
          </AccordionDetails>
        </Accordion>

        {/* Accordion para ESCO */}
        {verificaTipoCarga("esco") && (
          <Accordion
            expanded={expanded === "esco"}
            onChange={handleChangeAccordion("esco")}
            sx={{ boxShadow: "none", borderBottom: 1, borderColor: "divider" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="esco-content"
              id="esco-header"
            >
              <Typography fontWeight="bold" fontSize="1rem" color="text.secondary">
                ESCO
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ maxHeight: "300px", overflowY: "auto" }}>
              <Tabs orientation="vertical" variant="scrollable" value={false}>
                <Tab
                  label="Proposta Unificada"
                  onClick={() => handleTabClick("esco")}
                />
              </Tabs>
            </AccordionDetails>
          </Accordion>
        )}
      </Box>

      {/* Conteúdo principal */}
      <Box sx={{ width: "85%" }}>
        {tipoCargaSelecionada && (
          <ListTomadaPreco
            key={tipoCargaSelecionada} // Força re-renderização
            currProcesso={currProcesso}
            tipoCarga={tipoCargaSelecionada}
          />
        )}
      </Box>
    </Box>
  );
};

export default function AcompanhaOrcamentosFase1() {
  return <AcompanhaOrcamentosDinamico fase={1} />;
}
